import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "../commanstyles.module.css";
import { FaMinusSquare, FaPlusSquare } from "react-icons/fa";
import { IoMdLock } from "react-icons/io";
import { FiDownload } from "react-icons/fi";
import { IoDocumentTextOutline } from "react-icons/io5";

function RelatedPartyTransactions({ isSubScribe, data }) {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [isTableOpen, setIsTableOpen] = useState(true);
  const [selectedFinancialYear, setSelectedFinancialYear] = useState(
    data.length > 0 ? data[0].financialYear : ""
  );
  const rowsPerPage = 10;

  // Filter the data based on the selected financial year
  const filteredData = selectedFinancialYear
    ? data.filter((item) => item.financialYear === selectedFinancialYear)
    : data;

  const totalPages = Math.ceil(filteredData.length / rowsPerPage);

  // Handle page change
  const handleClick = (page) => {
    setCurrentPage(page);
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  // Get all unique financial years for the dropdown
  const financialYears = [...new Set(data.map((item) => item.financialYear))];

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentData = filteredData.slice(indexOfFirstRow, indexOfLastRow);

  // Toggle table visibility
  const toggleTable = () => {
    if (!isSubScribe) {
      alert("Please unlock to see the data.");
      return;
    }
    setIsTableOpen((prevState) => !prevState);
  };

  // Handle the financial year selection change
  const handleYearChange = (e) => {
    setSelectedFinancialYear(e.target.value);
    setCurrentPage(1); // Reset to the first page when the year changes
  };

  return (
    <div className={styles.table_subcontainer}>
      <div>
        {isSubScribe && (
          <div className={styles.highlet_header_content1}>
            <p className={styles.minuse_icon} onClick={toggleTable}>
              {isTableOpen ? (
                <FaMinusSquare size={22} />
              ) : (
                <FaPlusSquare size={22} />
              )}
            </p>
            <h3 className={styles.highlet_text}>
              {/* RELATED PARTY TRANSACTIONS FOR FY ENDING ON -
               31 Mar,{selectedFinancialYear || "All"} */}
              Related Party Transactions for FY Ending On
              {filteredData.length > 0 &&
                selectedFinancialYear &&
                `  - 31 Mar, ${selectedFinancialYear}`}
              {filteredData.length > 0 && (
                <div className={styles.yearSelectContainer}>
                  <select
                    id="financialYear"
                    value={selectedFinancialYear}
                    onChange={handleYearChange}
                  >
                    {/* <option value="" disabled>select Years</option> */}
                    {financialYears.map((year) => (
                      <option key={year} value={year}>
                        {/* {parseInt(year) + 1} */}
                        {parseInt(year) - 1} - {year}
                      </option>
                    ))}
                  </select>
                </div>
              )}
            </h3>
          </div>
        )}

        {/* Financial Year Dropdown */}

        {/* Reference Documents Section */}
        {isSubScribe && (
          <div>
            {filteredData.map((item) => (
              <div key={item.Id} className={styles.referencedoc_main}>
                <div>
                  <b>Reference Documents</b>
                </div>
                <div className={styles.referencedoc_container}>
                  {item.refDoc ? (
                    <>
                      <div>
                        {item.refDoc?.MaiinFileName && (
                          <a
                            href={item.refDoc?.fileurl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.referencedoc_mainfilename}
                            style={{
                              color: "#083A7F",
                              display: "inline-block",
                              marginBottom: "10px",
                              cursor: "pointer",
                            }}
                          >
                            {item.refDoc?.MaiinFileName}
                          </a>
                        )}
                        <ul style={{ padding: 0, margin: 0, listStyle: "none" }}>
                          {item.refDoc?.Attachments &&
                            item.refDoc?.Attachments.length > 0 ? (
                            item.refDoc?.Attachments.map((attachment, index) => (
                              <li
                                key={index}
                                className={styles.referencedoc_Attachments}
                                style={{ marginBottom: "8px", cursor: "pointer" }}
                              >
                                <IoDocumentTextOutline
                                  size={16}
                                  style={{ marginRight: "8px", color: "#2961EF", flexShrink: 0, cursor: "pointer" }}
                                />
                                <a
                                  href={attachment.fileurl}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    textDecoration: "none",
                                    color: "#2961EF",
                                    cursor: "pointer",
                                  }}
                                >
                                  {attachment.Name}
                                </a>
                                <button
                                  onClick={() => {
                                    const link = document.createElement("a");
                                    link.href = attachment.fileurl;
                                    link.download = attachment.Name;
                                    link.click();
                                  }}
                                  title="Download"
                                  style={{
                                    background: "none",
                                    border: "none",
                                    cursor: "pointer",
                                    color: "#F5B301",
                                    marginLeft: "10px",
                                    textDecoration: "underline",
                                  }}
                                >
                                  <FiDownload />
                                </button>
                              </li>
                            ))
                          ) : (
                            <span>No attachments available.</span>
                          )}
                        </ul>
                      </div>
                    </>
                  ) : (
                    <span>No documents available for selected year</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Table Section */}
        {isTableOpen && (
          <>
            {/* If not subscribed, show the subscription message */}
            {!isSubScribe && (
              <button className={styles.Subscription_msg} onClick={() => navigate("/kohere/mycredits", { state: { active: "BuyCredits" } })}>
                <IoMdLock /> Subscription required to view data
              </button>
            )}

            {/* If subscribed, show the table */}
            {isSubScribe && (
              <table className={styles.commantable}>
                <thead>
                  <tr className={styles.tableHeaderRow}>
                    <th className={styles.tableHeader}>S.No</th>
                    <th className={styles.tableHeader}>
                      Name(s) of the related party
                    </th>
                    <th className={styles.tableHeader}>
                      Nature of relationship
                    </th>
                    <th className={styles.tableHeader}>
                      Nature of contracts/ arrangements/ transactions
                    </th>
                    <th className={styles.tableHeader}>
                      Duration of the contracts/ arrangements / transactions
                    </th>
                    <th className={styles.tableHeader}>
                      Value of the contracts/ arrangements / transactions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {currentData.length > 0 ? (
                    currentData.map((row, index) => (
                      <tr key={row.Id} className={styles.tableRow}>
                        <td className={styles.tableCell}>{index + 1}</td>
                        <td className={styles.tableCell}>{row.name}</td>
                        <td className={styles.tableCell}>{row.relationship}</td>
                        <td className={styles.tableCell}>
                          {row.transactionType || "-"}
                        </td>
                        <td className={styles.tableCell}>
                          {row.financialYear || "-"}
                        </td>
                        <td className={styles.tableCell}>{row.amount}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className={styles.noData} style={{ textAlign: "center" }}>
                        No Related party transactions data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}

            {/* Pagination controls */}
            {isSubScribe && currentData.length > 0 && (
              <div className={styles.pagination}>
                <button onClick={handlePrevious} disabled={currentPage === 1}>
                  &lt;
                </button>
                {[...Array(totalPages).keys()].map((num) => (
                  <button
                    key={num + 1}
                    onClick={() => handleClick(num + 1)}
                    className={currentPage === num + 1 ? styles.active : ""}
                  >
                    {num + 1}
                  </button>
                ))}
                <button
                  onClick={handleNext}
                  disabled={currentPage === totalPages}
                >
                  &gt;
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default RelatedPartyTransactions;
